// extracted by mini-css-extract-plugin
export default {"form":"style_form__FKq2m","formInputBlock":"style_formInputBlock__Mf50y","formInputBlock2":"style_formInputBlock2__iCODq","formInput":"style_formInput__y5yK2"};